import type { CapturedFeedbackEntry } from 'components/MapPage/focFeedbackNoteBody';

/** In-memory step feedback for the current browser session, keyed by tour label. */
const byTour = new Map<string, Map<string, CapturedFeedbackEntry>>();

const noteIdByTour = new Map<string, string>();

export function getFocStepFeedback(
  tourLabel: string,
  requirementKey: string
): CapturedFeedbackEntry {
  return (
    byTour.get(tourLabel)?.get(requirementKey) ?? { reaction: '', text: '' }
  );
}

export function setFocStepFeedback(
  tourLabel: string,
  requirementKey: string,
  entry: CapturedFeedbackEntry
): void {
  let tourMap = byTour.get(tourLabel);
  if (!tourMap) {
    tourMap = new Map();
    byTour.set(tourLabel, tourMap);
  }
  tourMap.set(requirementKey, {
    reaction: entry.reaction,
    text: entry.text,
  });
}

export function hydrateFocStepFeedback(
  tourLabel: string,
  entries: Map<string, CapturedFeedbackEntry>
): void {
  const tourMap = new Map(entries);
  byTour.set(tourLabel, tourMap);
}

export function getFocFeedbackNoteId(tourLabel: string): string | null {
  return noteIdByTour.get(tourLabel) ?? null;
}

export function setFocFeedbackNoteId(tourLabel: string, noteId: string): void {
  noteIdByTour.set(tourLabel, noteId);
}

export function focStepRequirementKey(step: {
  id?: string;
  requirementId?: string;
  title: string;
}): string {
  if (step.requirementId?.trim()) {
    // Titles are built as `${requirementId} — ${name}`; prefer that full key.
    if (step.title.includes(step.requirementId)) return step.title;
    return `${step.requirementId} — ${step.title}`;
  }
  return step.title;
}
